/**
 * https://github.com/IdentityModel/oidc-client-js/wiki
 */
import Oidc from "oidc-client";

export default function Auth(ENV, $q, $location, UserStorage, Log) {
    const fn = this;

    const config = {
        authority: ENV.identityServer + "/.well-known/openid-configuration",
        client_id: "abook.www.v3.angularJS_WebClient",
        redirect_uri: ENV.domain + "/auth-callback",
        response_type: "code",
        scope: "openid profile email abook.api.v3.scope.access",
        post_logout_redirect_uri: ENV.domain,
    };

    fn.mgr = new Oidc.UserManager(config);

    /**
     * used by authInterceptor
     */
    fn.getProfileToken = function () {
        return fn.mgr.getUser().then((user) => {
            if (user) {
                return user.access_token;
            } else {
                return null;
            }
        });
    };

    /**
     * used at some routes to authenticate USER
     */
    fn.getProfile = function () {
        return fn.mgr.getUser().then((user) => {
            if (user == null) return null;
            return user.profile;
        });
    };

    /**
     * used as to identiy whether the user is logged in or not
     */
    fn.getProfileId = function () {
        return fn.mgr.getUser().then((user) => {
            return user ? parseInt(user.profile.sub) : $q.reject("No access");
        });
    };

    fn.login = function () {
        let state = window.location.href;

        /**
         * locations we do not wish users to return to after login..
         */
        if ($location.path() == "/account/create") {
            state = null;
        }

        fn.mgr.signinRedirect({ state: state });
    };

    fn.logout = function () {
        fn.mgr
            .clearStaleState()
            .then(() => {
                Log.string("AUTH - logout: ", "clearState success");

                fn.mgr.signoutRedirect();
            })
            .catch((e) => {
                Log.string("AUTH : ", "clearStateState error", e.message);
            });
    };

    /**
     * EVENTS
     *
     */
    fn.addEvents = function () {
        fn.mgr.events.addAccessTokenExpiring(function () {
            Log.string("AUTH : ", "addAccessTokenExpiring: token expiring...");
        });

        fn.mgr.events.addUserLoaded(function () {
            Log.string(
                "AUTH : ",
                "userLoaded: Raised when a user session has been established (or re-established)."
            );
        });

        fn.mgr.events.addUserUnloaded(function () {
            Log.string(
                "AUTH : ",
                "userUnloaded: Raised when a user session has been terminated."
            );
        });

        fn.mgr.events.addAccessTokenExpiring(function () {
            Log.string(
                "AUTH : ",
                "accessTokenExpiring: Raised prior to the access token expiring."
            );
        });

        fn.mgr.events.addAccessTokenExpired(function () {
            Log.string(
                "AUTH : ",
                "accessTokenExpired: Raised after the access token has expired."
            );

            Log.string("AUTH : ", "login user again");
            // TO DO ::: MEDIUM ::: AUTH modal? Instead of redirecting directly to the authserrver perhaps we could have a modal that pops up when the user needs to sign in again?

            fn.login();
        });

        fn.mgr.events.addSilentRenewError(function () {
            Log.string(
                "AUTH : ",
                "silentRenewError: Raised when the automatic silent renew has failed."
            );
        });

        fn.mgr.events.addUserSignedOut(function () {
            Log.string(
                "AUTH : ",
                "userSignedOut [1.1.0]: Raised when the user's sign-in status at the OP has changed."
            );

            // $location.path("account/logout"); //

            fn.login();

            // TO DO ::: MEDIUM ::: User Auth expired - fixed by calling login.. but is this good enough ?
        });

        fn.mgr.events.addUserSignedIn(function () {
            Log.string(
                "AUTH : ",
                "userSignedIn [1.1.0]: Raised when the user's sign-in status at the OP has changed."
            );
        });
    };

    fn.addEvents();

    /**
     *  auth-callback resolve
     */
    fn.signinRedirectCallback = () => {
        Log.string("AUTH : ", "signinRedirectCallback called");
        new Oidc.UserManager({ response_mode: "query" })
            .signinRedirectCallback()
            .then((user) => {
                Log.string("AUTH : ", "signinRedirectCallback ok");

                // TEST ::: new user login
                // user.profile.sub = "144";

                // const prevUserId = UserStorage.getLastLoggedUserId();

                // UserStorage.setUserSwitchDetected(
                //     prevUserId !== user.profile.sub
                //         ? prevUserId
                //             ? true
                //             : false
                //         : false
                // );

                // UserStorage.setLastLoggedUserId(user.profile.sub);

                window.location = user.state || "/"; // redirect back to where user came from

                //$location.path("/");
            })
            .catch((e) => {
                Log.string("AUTH : ", "signinRedirectCallback Error");
                console.error(e);

                fn.mgr
                    .clearStaleState()
                    .then(() => {
                        Log.string(
                            "AUTH : clearStaleState",
                            "clearState success"
                        );
                        fn.logout();
                    })
                    .catch((e) => {
                        Log.string(
                            "AUTH : ",
                            "clearStateState error: " + e.message
                        );
                    });
            });
    };
}
